<template>
    <div>
        <md-sidenav class="md-left collaboratorsNav" ref="collaboratorsNav">
            <md-toolbar class="md-dense main-toolbar">
                <md-button class="md-icon-button" @click="back()">
                    <md-icon>menu</md-icon>
                </md-button>
                <h3 class="md-title">Collaborators</h3>
            </md-toolbar>
            <md-list class="md-double-line">
                <md-subheader>Current Collaborators</md-subheader>
                <md-list-item v-if="owner">
                    <md-avatar>
                        <img :src="owner.profile_picture" alt="People" v-if="owner.profile_picture" />
                        <img :src="require('../../assets/img/silhouette.jpg')" v-else alt="People" />
                    </md-avatar>
                    <div class="md-list-text-container collaborator-text-container">
                        <span><strong>{{owner.username}}</strong></span>
                        <div>
                            <span class="role-text-edit" v-if="!isAdministrator">{{project.ownerRole}}</span>
                            <span class="role-text-edit" v-else contenteditable v-on:keydown.esc="cancelEdit" v-on:keydown.left="ignoreKeydown" v-on:keydown.right="ignoreKeydown" v-on:keydown.enter="saveEdit(owner.uid, $event)" @blur="stopEdit(owner.uid, $event)">{{project.ownerRole}}</span>
                            <span style="color: #999;">(Project Owner)</span></div>
                        <span>{{owner.email}}</span>
                    </div>
                </md-list-item>
                <collaborator v-if="subCollaborators.length > 0" v-for="collab in subCollaborators"
                    :user="user"
                    :collabUser="collabUsers[collab.uid]"
                    :collaborator="collab"
                    :editable="isAdministrator"
                    :layers="layers"
                    :key="collab.uid" 
                    @removeCollaborator="removeCollaborator" 
                    @openCollaboratorAccessModal="openCollaboratorAccessModal"
                    @close="emitClose"
                />
            </md-list>
            <md-list class="md-double-line pendingCollaboratorList">
                <md-subheader>Pending Collaborators</md-subheader>
                <pendingCollaborator v-if="pendingCollaborators.length > 0" v-for="collab in pendingCollaborators"
                    :collaborator="collab"
                    :editable="user.uid === owner.uid"
                    :key="collab.id" 
                    @removePendingCollaborator="removePendingCollaborator"
                    @resendInvitation="resendInvitation"
                />
            </md-list>
            <md-list>
                <invite v-if="canEdit" :project="project" @addCollaborator="addCollaborator"/>
            </md-list>
        </md-sidenav>
        <md-dialog class="collaborator-access-modal" ref="change-collaborator-access" @open="onCollaboratorAccessModalOpen" @close="onCollaboratorAccessModalClose" >
            <md-dialog-title>Collaborator Access</md-dialog-title>
            <md-dialog-content style="display: flex;" v-if="collaborator">
                <div v-if="isLoadingUserInfo" class="loading-state">
                    <md-spinner :md-size="60" md-indeterminate></md-spinner>
                </div>
                <div
                    v-else-if="collaborator.userInfo"
                    class="collaborator-access-options-content"
                >
                    <md-input-container :class="{'md-input-invalid': !collaborator.role}">
                        <label for="collaborator-role">Role</label>
                        <md-input id="collaborator-role" v-model="collaborator.role" required :disabled="!isAdministrator && (collaborator.uid !== user.uid)"></md-input>
                    </md-input-container>
                    <div v-if="restriction.restricted" class="observer-access-note">
                        <p>{{ observerText }}</p>
                        <p v-if="restriction.inactiveAdmin">{{ inactiveAdminNote }}</p>
                    </div>

                    <div class="collaborator-access-options">
                        <p>Change the collaborator access for <strong>{{ collaborator.name }}</strong><span v-if="restriction.restricted" class="observer-tag"> (Observer)</span> on this project</p>
                        <div class="collaborator-access-option observer-option" v-if="options.showObserver">
                            <md-radio v-model="displayedType" mdValue="observer" disabled>Observer</md-radio>
                            <p>Can view this production, but cannot edit it.</p>
                        </div>
                        <div class="collaborator-access-option">
                            <md-radio v-model="displayedType" mdValue="member" :disabled="options.disabled.member">Member</md-radio>
                            <p>Can create layers and notes, but cannot alter the script; delete history snapshots; change collaborator access or remove collaborators.</p>
                        </div>
                        <div class="collaborator-access-option">
                            <md-radio v-model="displayedType" mdValue="administrator" :disabled="options.disabled.administrator">Administrator</md-radio>
                            <p>Has full access to the entire project, but cannot delete the project.</p>
                        </div>
                        <div class="collaborator-access-option" v-if="isOwner">
                            <md-radio v-model="displayedType" mdValue="transfer" :disabled="options.disabled.transfer">Transfer Ownership</md-radio>
                            <p>Collaborator will become the new owner of this project and will have full access to this project. You will be immediately downgraded to an Administrator and you will lose the ability to delete the project.</p>
                        </div>
                        <div
                            v-if="collaboratorType === 'member'"
                            class="collaborator-access-option collaborator-structure-permission">
                            <md-checkbox
                                v-model="canEditStructure"
                                :disabled="options.disabled.structure"
                                id="collaborator-can-edit-structure">
                                Can edit Structure
                            </md-checkbox>
                            <p>Allow this member to place and manage Act / Scene / Song structure markers. Administrators and project owners always have this permission.</p>
                        </div>
                        <div
                            v-else-if="collaboratorType === 'administrator'"
                            class="collaborator-access-option collaborator-structure-permission structure-always">
                            <md-checkbox v-model="adminStructureAlways" disabled id="collaborator-can-edit-structure-admin">
                                Can edit Structure
                            </md-checkbox>
                            <p>Administrators always have Structure edit access.</p>
                        </div>
                    </div>
                </div>
            </md-dialog-content>
            <md-dialog-actions>
                <md-button class="md-raised" @click="action_remove_collaborator" :disabled="!isAdministrator && !isCollaboratorOwner">Remove Collaborator</md-button>
                <md-button v-if="collaborator && collaborator.userInfo" class="md-raised" @click="action_save_changes" :disabled="!isAdministrator">Change Access</md-button>
            </md-dialog-actions>
        </md-dialog>
        <md-dialog-confirm
            :md-title="'Remove Collaborator'"
            :md-content-html="'Do you really want to remove this collaborator from project?'"
            :md-ok-text="'Yes'"
            :md-cancel-text="'No'"
            @close="confirm_remove_collaborator_action"
            ref="confirm-remove-collaborator-modal"
        ></md-dialog-confirm>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

import NavBus from '@/buses/nav';
import CollaboratorsCollaborator from '@/components/collaborators/collaborator';
import CollaboratorsPendingCollaborator from '@/components/collaborators/pending-collaborator';
import CollaboratorsInvite from '@/components/collaborators/invite';

import { inviteSubject, inviteBody } from '@/lib/inviteEmail';
import { projectAccessInfo } from '@/lib/user-profiles';
import { accessRestriction, observerExplanation, accessOptionState, INACTIVE_ADMIN_NOTE } from '@/lib/observer-access';
import { makeAccessInfoCache } from '@/lib/access-info-cache';

import { sendMail } from '@/lib/sendMail';

// One cache for the session: the panel prefetches, the dialog reads (1 Oct 2026, cold starts).
const accessInfoCache = makeAccessInfoCache(pid => projectAccessInfo(pid));

const CollaboratorsNav = {
    name: 'CollaboratorsNav',
    props: [],
    data: function() {
        return {
            collaborator: null,
            collaboratorType: '',
            canEditStructure: false,
            adminStructureAlways: true,
            ownerData: null,
            isLoadingUserInfo: false,
            accessInfo: null,
            inactiveAdminNote: INACTIVE_ADMIN_NOTE,
            collabUsers: {}
        };
    },
    computed: {
        ...mapGetters([
            'project',
            'user',
            'collaborators',
            'collaboratorByUID',
            'pendingCollaborators',
            'userByUID',
            'layers',
            'ownerUID'
        ]),
        owner() {
            return this.ownerData;
        },
        isOwner() {
            return this.user.uid === this.owner.uid;
        },
        isAdministrator() {
            const collab = this.collaboratorByUID(this.user.uid);
            return this.ownerUID === this.user.uid || (collab && collab.type === 'administrator');
        },
        isCollaboratorOwner() {
            return this.collaborator && this.collaborator.uid === this.user.uid;
        },
        canEdit() {
            return this.collaboratorByUID(this.user.uid) || this.ownerUID === this.user.uid;
        },
        subCollaborators() {
            return this.collaborators.filter(collabUser => collabUser.uid);
        },
        // Observer accounts (1 Oct 2026): see lib/observer-access.js. Based on the
        // STORED type, so an existing Observer-Administrator is recognised (option a).
        restriction() {
            if (!this.collaborator) return { restricted: false, isObserver: false, inactiveAdmin: false };
            return accessRestriction({
                project: this.project,
                uid: this.collaborator.uid,
                type: this.collaborator.type,
                accessInfo: this.accessInfo
            });
        },
        // What the radios show. For an Observer on a normal production it is the
        // read-only "Observer" option (4 Oct 2026, Josh): the stored type is never
        // changed by this, and saving sends the stored type back unchanged.
        options() {
            return accessOptionState({
                restricted: this.restriction.restricted,
                isOwner: this.isOwner,
                isAdministrator: this.isAdministrator,
                type: this.collaboratorType
            });
        },
        displayedType: {
            get() {
                return this.options.selected;
            },
            set(value) {
                if (!this.restriction.restricted) this.collaboratorType = value;
            }
        },
        observerText() {
            if (!this.collaborator) return '';
            return observerExplanation({
                name: this.collaborator.name || (this.collaborator.userInfo && this.collaborator.userInfo.username),
                ownerPlanFamily: this.accessInfo && this.accessInfo.ownerPlanFamily,
                viewerIsOwner: !!this.owner && this.user.uid === this.owner.uid
            });
        }
    },
    methods: {
        async collabUserData(collabID) {
            if (!this.collabUsers[collabID]) {
                try {
                    const user = await this.userByUID(collabID);
                    this.$set(this.collabUsers, collabID, user);
                } catch (error) {
                    console.error('Error fetching user data:', error);
                }
            }
            return this.collabUsers[collabID];
        },
        emitClose() {
            this.$refs.collaboratorsNav.close();
            this.$emit('close');
        },
        back() {
            this.$refs.collaboratorsNav.close();
            NavBus.$emit('main-nav.open');
        },
        addCollaborator(collab) {
            // Always create a pending invitation so it shows under Pending
            // Collaborators (owner) and Pending Project Invites (invitee).
            // Notes List roster sync still runs when the invitee accepts
            // (addCollaborator → syncNotesListProjectRoster).
            this.$store.dispatch('addPendingCollaborator', {
                project: this.project,
                collaborator: collab,
                inviter: this.user.uid
            });
        },
        removeCollaborator(collabID) {
            this.$store.dispatch('removeCollaborator', {
                project: this.project,
                collaboratorID: collabID
            });
        },
        removePendingCollaborator(collabID) {
            this.$store.dispatch('removePendingCollaborator', {
                project: this.project,
                pendingCollaboratorID: collabID
            });
        },
        generateEmailBody: function(collaborator) {
            return inviteBody({
                project: this.project,
                recipientName: collaborator.name,
                inviterName: this.user.username,
                inviterEmail: this.user.email,
                host: document.URL.split('/')[2] || 'app.thecuelist.com'
            });
        },
        resendInvitation(collaborator) {
            const postData = {
                email: collaborator.email,
                subject: inviteSubject(this.project),
                content: this.generateEmailBody(collaborator)
            };

            return sendMail(postData)
                .then(() => this.$toast.success('Invitation email sent successfully.'))
                .catch((error) => {
                    console.error('Email sending failed:', error);
                    this.$toast.error('Failed to send invitation email. Please try again.');
                    throw error;
                });
        },
        ignoreKeydown(e) {
            e.stopPropagation();
        },
        cancelEdit(e) {
            document.execCommand('undo');
            e.target.blur();
        },
        saveEdit(attr, e) {
            e.preventDefault();
            e.target.blur();
        },
        stopEdit(uid, e) {
            if (uid === this.project.ownerUID) {
                if (!e.target.innerText) {
                    e.target.innerText = 'Project Owner';
                }
                this.$store.dispatch('updateProjectOwnerRole', e.target.innerText);
            }
        },
        async openCollaboratorAccessModal(collaborator) {
            this.isLoadingUserInfo = true;
            this.collaborator = {...collaborator};
            this.accessInfo = null;
            try {
                const pid = this.project && this.project.id;
                const [userInfo, cachedInfo] = await Promise.all([
                    this.userByUID(collaborator.uid),
                    accessInfoCache.get(pid)
                ]);
                let accessInfo = cachedInfo;
                // Someone who joined after the prefetch is not in the cached answer yet.
                if (accessInfo && accessInfo.observers && !(collaborator.uid in accessInfo.observers)) {
                    accessInfoCache.invalidate(pid);
                    accessInfo = await accessInfoCache.get(pid);
                }
                this.accessInfo = accessInfo;
                this.collaborator.userInfo = userInfo;
                if (!this.collaborator.type) this.collaborator.type = 'member';
                this.collaboratorType = this.collaborator.type;
                this.canEditStructure = this.collaborator.canEditStructure === true;
            } catch (error) {
                console.error('Error loading user info:', error);
            } finally {
                this.isLoadingUserInfo = false;
            }
            await this.$refs['change-collaborator-access'].open();
        },
        action_save_changes() {
            if (!this.collaborator.role) {
                return;
            }

            // The actions refuse Observer changes the dialog greys out; say so if a
            // stale screen ever sends one.
            const refused = (err) => {
                console.warn('[collaborator-access]', err && err.message);
                this.$toast.error((err && err.message) || 'That access change is not available.');
            };
            if (this.collaboratorType === 'transfer') {
                // Refresh the access lookup once the transfer has landed; the owner row follows via the ownerUID watcher.
                this.$store.dispatch('transferProjectOwnership', {
                    target: this.collaborator
                }).then(() => this.refreshAccessInfo()).catch(refused);
            } else {
                this.$store.dispatch('updateCollaboratorOptions', {
                    uid: this.collaborator.uid,
                    role: this.collaborator.role,
                    type: this.collaboratorType,
                    canEditStructure: this.collaboratorType === 'member'
                        ? this.canEditStructure === true
                        : false
                }).catch(refused);
            }
            this.refreshAccessInfo();
            this.$refs['change-collaborator-access'].close();
        },
        // After any access change, drop the cached answer and fetch it again in the background.
        refreshAccessInfo() {
            const pid = this.project && this.project.id;
            accessInfoCache.invalidate(pid);
            accessInfoCache.prefetch(pid);
        },
        action_remove_collaborator() {
            this.$refs['confirm-remove-collaborator-modal'].open();
        },
        onCollaboratorAccessModalOpen() {
        },
        onCollaboratorAccessModalClose() {
            this.accessInfo = null;
        },
        confirm_remove_collaborator_action(type) {
            if (type === 'ok') {
                const uid =
                    (this.collaborator && (this.collaborator.uid || this.collaborator.id)) ||
                    null;
                if (!uid) {
                    console.error('[noteslist-integration] confirm remove missing collaborator uid');
                    return;
                }
                this.removeCollaborator(uid);
                this.refreshAccessInfo();
                this.$refs['change-collaborator-access'].close();
            }
        },
        async fetchOwner() {
            const owner = await this.userByUID(this.project.ownerUID);
            this.ownerData = owner;
        },
        async loadCollaboratorData() {
            await Promise.all(
                this.subCollaborators.map(collab => 
                    this.collabUserData(collab.uid)
                )
            );
        }
    },
    created: function() {
        this.fetchOwner();
        NavBus.$on('collaborators-nav.open', () => {
            if (this.$refs.collaboratorsNav) {
                this.$refs.collaboratorsNav.open();
            }
            // Warm the Observer lookup now, so Collaborator Access opens without waiting.
            accessInfoCache.prefetch(this.project && this.project.id);
        });
        this.loadCollaboratorData();
    },
    watch: {
        // The owner's profile was fetched once on open, so after Transfer Ownership the panel showed the old owner
        // until a refresh (Josh, 10 Oct 2026). Re-fetch whenever the project's owner changes.
        ownerUID: 'fetchOwner',
        subCollaborators: {
            handler: 'loadCollaboratorData',
            immediate: true
        }
    },
    beforeDestroy: function() {
        NavBus.$off('collaborator-nav.open');
    },
    components: {
        collaborator: CollaboratorsCollaborator,
        pendingCollaborator: CollaboratorsPendingCollaborator,
        invite: CollaboratorsInvite
    }
};
export default CollaboratorsNav;

</script>

<style lang="scss">
.pendingCollaboratorList {
    .md-list-item {
        background-color: lighten(#5ecfdf, 30%);
        .md-list-item-container {
            background-color: lighten(#5ecfdf, 30%) !important;
        }
    }
}
.collaboratorsNav {
    .md-title {
        font-weight: 700;
    }
    .md-subheader {
        font-weight: 100;
        font-size: 18px;
        color: #333;
        &.md-theme-show-mode {
            color: rgba(255, 255, 255, 0.87);
        }
    }

    .collaborator-role-wrapper {
        z-index: 2;
        min-height: 1rem;
        span {
            display: block;
            min-height: 1rem;
        }
    }
}

.collaborator-access-modal {
    top: 40px;
    
    .md-dialog {
        max-width: 640px;
    }
    .md-dialog-title {
        background: #081e4f;
        font-size: 40px;
        line-height: 1.4;
        text-align: center;
        color: white;
        padding: 1rem;
    }
    .md-dialog-content {
        // Centre vertically with auto margins, not align-items: center. Flex centring pushes the top of
        // content taller than the dialog above the scroll origin, where it can never be scrolled to: that
        // cut off the Observer note (Josh, 1 Oct 2026). Auto margins fall back to 0 when content overflows.
        > * {
            margin-top: auto;
            margin-bottom: auto;
        }
        .observer-access-note {
            border: 1px solid #e0e0e0;
            padding: 12px 16px;
            margin-bottom: 24px;
            p {
                color: #666;
                line-height: 1.3;
                margin: 0;
            }
            p + p {
                margin-top: 8px;
            }
        }
        .observer-tag {
            color: #999;
        }
        .collaborator-access-options-content {
            // With the Observer note above, match the Role-to-note gap (24px) instead of the full 45px.
            .observer-access-note + .collaborator-access-options {
                margin-top: 0;
                > p:first-child {
                    margin-top: 0;
                }
            }
            .collaborator-access-options {
                margin-top: 45px;
                .collaborator-access-option {
                    .md-radio {
                        margin-bottom: 0;
                    }
                    p {
                        color: #666;
                        margin-left: 28px;
                        margin-top: -3px;
                        line-height: 1.2;
                    }
                    // An option the viewer cannot choose reads as unavailable, not just its control
                    // (Josh, 1 Oct 2026). Not the admin "always has Structure" box: that one is information.
                    &:not(.structure-always):not(.observer-option) .md-radio.md-disabled,
                    &:not(.structure-always):not(.observer-option) .md-checkbox.md-disabled {
                        cursor: not-allowed;
                        .md-radio-label,
                        .md-checkbox-label {
                            color: #999;
                            cursor: not-allowed;
                        }
                        + p {
                            color: #999;
                        }
                    }
                    // The read-only Observer option is the collaborator's current state:
                    // shown selected and in normal colours, just not changeable.
                    &.observer-option .md-radio.md-disabled {
                        cursor: default;
                        .md-radio-label { color: inherit; cursor: default; }
                    }
                    &.collaborator-structure-permission {
                        margin-top: 12px;
                        padding-top: 8px;
                        border-top: 1px solid #e0e0e0;
                    }
                }
            }
        }
    }
    .md-error {
        color: #e5424d;
        font-size: 12px;
    }
    .md-dialog-actions {
        justify-content: space-between;
        padding: 32px 24px;
    }
    .loading-state {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        min-height: 200px;
    }
}
</style>


// WEBPACK FOOTER //
// nav.vue?733e72a8